/**
 * Glaze color definitions for mosaic tiles.
 *
 * This file contains all the available glaze colors with their hex values.
 * Colors are used throughout the mosaic visualization system for tile rendering
 * and color selection options.
 */

export const glazeColors = {
    // Matte finishes
    'Azul Matte': '#012074',
    'Bonsai Matte': '#594f38',
    'Carbon Matte': '#494343',
    'Cardamom Matte': '#d5c4b2',
    'Chaparral Matte': '#755933',
    'Feldspar Matte': '#e2d9cf',
    'Garnet Matte': '#5d1d19',
    'Ivory Matte': '#e5dbcf',
    'Kalamata Matte': '#73676a',
    'Limewash Matte': '#acaa9f',
    'Mustard Seed Matte': '#a88a1a',
    'Raven Matte': '#080808',
    'Rosemary Matte': '#b5c0af',
    'Sand Dune Matte': '#ddd3c9',
    'Sweet Pea Matte': '#c4b0a4',
    'Tempest Matte': '#4f5c55',

    // Standard finishes
    Overcast: '#e8eaed',
    Sandstone: '#907b66',
    Indigo: '#4e595f',
    'Bone Black': '#0a0a0b',
    'Tyrian Purple': '#d4cac3',
    'Salt Creek': '#e8eaed',
    'Terre Verde': '#9a9f91',
    'Green Apatite': '#3b3d29',
    'Red Jasper': '#be9b91',
    'Sap Green': '#7c703e',
    'Egyptian Blue': '#bdcde4',
    'Red Iron Oxide': '#753800',
    'Azo Green': '#bca854',
    'Titanium Grey': '#b2b4b8',
    'Flake White': '#ffffff',
};
